export default function Skyline({ className = "" }) {
  return (
    <svg viewBox="0 0 1200 160" className={className} fill="none" aria-hidden="true" preserveAspectRatio="xMidYMax meet">
      <path
        className="skyline-line"
        d="M0 158 V118 H45 V96 H85 V132 H125 V78 H165 V112 H205 V88 H250 V138 H295 V70 H340 V138 H390 V104 H440 V124 H490 V84 H540 V130 H585 V100 H635 V140 H685 V70 H695 V44 H705 V70 H715 V44 H725 V70 H755 V142 H805 V96 H855 V118 H905 V66 H955 V134 H1005 V104 H1055 V142 H1105 V90 H1155 V122 H1200 V158"
        stroke="hsl(var(--gold))"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}
